import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { IGameSummary } from '@soposopo/sopo-models';
import * as GameHistoryActions from './gameHistory.actions';
import { GameHistory } from './gameHistory.state';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { GameStateId } from '../game/game.state';

@Injectable()
export class GameHistoryStoreDispatcher {
    constructor(private store: Store<AppState>) {}

    receiveHandHistory(handID: string, summary: IGameSummary, events: any[]) {
        //this.store.dispatch(new ReceiveGameSummary(summary, handID, events));
    }

    loadHandHistoryFromStorage(gameStateId: GameStateId) {
        this.store.dispatch(GameHistoryActions.saveGameHistoryToStorage({gameStateId}));
    }

    previousHistory(gameStateId: GameStateId) {
        this.store.dispatch(GameHistoryActions.selectPreviousHandHistoryAction({gameStateId}));
    }

    nextHistory(gameStateId: GameStateId) {
        this.store.dispatch(GameHistoryActions.selectNextHandHistoryAction({gameStateId}));
    }

    goToSummary(gameStateId: GameStateId) {
        this.store.dispatch(GameHistoryActions.displaySummary({gameStateId}));
    }

    goToDetails(gameStateId: GameStateId) {
        this.store.dispatch(GameHistoryActions.displayDetails({gameStateId}));
    }

    resetHistoryCounter(gameStateId) {
        this.store.dispatch(GameHistoryActions.resetHandHistoryCounter({gameStateId}));
    }

    private getHistoryState() {
        return this.store.select((state: AppState) => state.gameHistory).pipe(filter((gameHistoryState) => gameHistoryState != null)); 
    }

    /** Returns an Observable of non-null GameStates */
    public getState(gameStateId: GameStateId): Observable<GameHistory> {
        return this.getHistoryState().pipe(
            filter(state => state.gameHistories[gameStateId] != null ),
            map(state => state.gameHistories[gameStateId]),
        );
    }
}
